import { GENERATION_TOOL } from 'src/data/generationTool';

export const initSelectedTool = ({
  defaultGenerationTool,
  isLongForm,
  currentFreestyleTool,
  generationTool,
}) => {
  if (defaultGenerationTool) return GENERATION_TOOL.freestyle;
  if (isLongForm) return GENERATION_TOOL.longFormBlank;

  return currentFreestyleTool?.generationTool || generationTool || GENERATION_TOOL.freestyle;
};
